import { React, useState, useEffect, useContext } from "react";
import { AppContext } from '../../../../AppStore';
import styled from "styled-components";
import {
    ResponsiveContainer,
    ComposedChart,
    Line,
    Area,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
} from 'recharts';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import GridNoRow from '../../../../common/GridNoRow';
import axios from "axios";
import Swal from "sweetalert2";
import Moment from 'moment';
import "moment/locale/ko";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Chart } from "react-google-charts";
import { useNavigate, useLocation } from "react-router-dom";

const MachineRuningStatus = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [tabID, setTabID] = useState();
    const [tabType, setTabType] = useState();
    const [machineReady, setMachineReady] = useState('N');
    const [timeLineData, setTimeLineData] = useState([
          [
            { type: "string", id: "Room" },
            { type: "string", id: "Name" },
            { type: "date", id: "Start" },
            { type: "date", id: "End" },
          ],
          [
              "기간",
              "오프라인",
              new Date(0, 0, 0, 0, 0, 0),
              new Date(0, 0, 0, 8, 0, 0),
          ],
          [
              "기간",
              "가동",
              new Date(0, 0, 0, 8, 0, 0),
              new Date(0, 0, 0, 16, 0, 0),
          ],
          [
              "기간",
              "정지",
              new Date(0, 0, 0, 16, 0, 0),
              new Date(0, 0, 0, 24, 0, 0),
          ],
    ]);
    const [runPieData, setRunPieData] = useState([
        ["상태", "가동률"],
        ["가동", 1],
        ["정지", 1],
        ["홀드", 1],
        ["MSRT", 1],
        ["오프라인", 1],
    ]);
    const [autPieData, setAutPieData] = useState([
        ["Element", "분", { role: "style" }],
        ["MDI", 1, "#b87333"], // RGB value
        ["EDIT", 1, "silver"], // English color name
        ["HND", 1, "gold"],
        ["JOG", 1, "color: #e5e4e2"], // CSS-style declaration
        ["REF", 1, "color:rgb(35, 151, 36)"], // CSS-style declaration
        ["MEM", 1, "color:rgb(33, 157, 184)"], // CSS-style declaration
        ["ETC", 1, "color:rgb(57, 37, 139)"], // CSS-style declaration
    ]);
    const [projectPie, setProjectPie] = useState(
        [[
        ["비율", "프로젝트"],
        [0, ""]
        ],
        [
        ["비율", "프로젝트"],
        [0, ""]
        ]]
    );
    const [machineInfo, setMachineInfo] = useState({
        machine_id:0,
        machine_type:0,
        machine_resource_id:0,
        machine_name:'',
        machine_ip:'',
        machine_port:'',
        machine_location:'',
        machine_comment:'',
    });
    const [timeLineOption, setTimeLineOption] = useState({
        timeline: { showRowLabels: false },
        avoidOverlappingGridLines: false,
        colors: ["#cbb69d", "#603913", "#c69c6e"],
    });
    const runPie_option = {
        title: "가동상태",
        titleTextStyle: { fontSize: 25, fontName: 'Arial'},
        colors: ["rgb(104, 171, 38)","#D84B16","#FFB737","#F1A7C9", "rgb(57, 54, 54)"],
        legend: {position: "right", alignment: "center",textStyle: {color: "#233238",fontSize: 13,},},
    };
    const antPie_option = {
        title: "가동모드",
        titleTextStyle: { fontSize: 25, fontName: 'Arial'},
        colors: ["rgb(245, 123, 123)", "rgb(232, 215, 105)","rgb(128, 236, 104)","rgb(88, 136, 233)", "rgb(212, 95, 239)", "rgb(57, 54, 54)", "rgb(211, 141, 43)"],
        legend: {position: "right", alignment: "center",textStyle: {color: "#233238",fontSize: 13,},},
    };
    const projectPie_option = {
        title: "프로젝트",
        titleTextStyle: { fontSize: 25, fontName: 'Arial'},
        colors: ["rgb(232, 176, 141)","rgb(206, 141, 232)","rgb(141, 231, 232)", "rgb(232, 141, 141)", "rgb(151, 236, 91)"],
        legend: {position: "right", alignment: "center",textStyle: {color: "#233238",fontSize: 13,},},
    };
    const [statusPie, setStatusPie] = useState([
        ["상태", "상태값"]
    ]);
    const statusPie_option = {
        title: "가동상태",
        titleTextStyle: { fontSize: 25, fontName: 'Arial',},
        colors: ["rgb(104, 171, 38)","#D84B16"],
        legend: {position: "right", alignment: "center",textStyle: {color: "#233238",fontSize: 13,},},
    };
    const [errorPie, setErrorPie] = useState([
        ["상태", "불량율"]
    ]);
    const errorPie_option = {
        title: "불량율",
        titleTextStyle: { fontSize: 25, fontName: 'Arial',},
        colors: ["#2196F3","#F44336"],
        legend: {position: "right", alignment: "center",textStyle: {color: "#233238",fontSize: 13,},},
    };
    const [errorTypePie, setErrorTypePie] = useState([
        ["상태", "불량유형"]
    ]);
    const errorTypePie_option = {
        title: "불량유형",
        titleTextStyle: { fontSize: 25, fontName: 'Arial',},
        colors: ["#D84B16","#FFB737","rgb(232, 141, 141)"],
        legend: {position: "right", alignment: "center",textStyle: {color: "#233238",fontSize: 12.5,},},
    };
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [columns2, setColumns2] = useState([]);
    const [columns4, setColumns4] = useState([]);

    const handleSetting = () => {
        setColumns([
            { field: 'id', headerName: 'id', width: 0, headerAlign: 'center', align:'center' },
            { field: 'date', headerName: '일시', width: 180, headerAlign: 'center', align:'center' },
            { field: 'project_name', headerName: '프로젝트', width: 150, headerAlign: 'center', align:'center' },
            { field: 'produce_count', headerName: '누적생산수량', width: 150, type: 'nubmer', headerAlign: 'center', align:'right' },
            { field: 'target_count', headerName: '목표생산수량', width: 150, type: 'nubmer', headerAlign: 'center', align:'right' },
            { field: 'run', headerName: '가동상태', width: 120, headerAlign: 'center', align:'center' },
            { field: 'aut', headerName: '가동모드', width: 120, headerAlign: 'center', align:'center' },
            { field: 'logdata', headerName: '이력', width: 750, headerAlign: 'center', align:'left' },
        ]);
        setColumns2([
            { field: 'id', headerName: 'id', width: 0, headerAlign: 'center', align:'center' },
            { field: 'date', headerName: '일시', width: 180, headerAlign: 'center', align:'center' },
            { field: 'status_name', headerName: '상태', width: 100, headerAlign: 'center', align:'center' },
            { field: 'logdata', headerName: '이력', width: 750, headerAlign: 'center', align:'left' },
        ]);
        setColumns4([
            { field: 'id', headerName: 'id', width: 0, headerAlign: 'center', align:'center' },
            { field: 'date', headerName: '일시', width: 180, headerAlign: 'center', align:'center' },
            { field: 'produce_count', headerName: '생산수량', width: 100, type: 'nubmer', headerAlign: 'center', align:'right' },
            { field: 'produce_ok_count', headerName: '정상수량', width: 100, type: 'nubmer', headerAlign: 'center', align:'right' },
            { field: 'produce_ng_count', headerName: '불량수량', width: 100, type: 'nubmer', headerAlign: 'center', align:'right' },
            { field: 'status_name', headerName: '상태', width: 100, headerAlign: 'center', align:'center' },
            { field: 'logdata', headerName: '이력', width: 750, headerAlign: 'center', align:'left' },
        ]);
    }

    const [columnVisibilityModel, setColumnVisibilityModel] = useState({
        id: false,
        date: true,
        workname: true,
        project: true,
        workcount: true,
        workcount_plus: true
    });

    // === [ADD] 요약 KPI 상태값 (원하시면 API 응답으로 set* 해주세요)
    const [summary_run_time, setSummaryRunTime] = useState('00:00');
    const [summary_run_predict_count, setSummaryRunPredictCount] = useState(0);
    const [summary_run_count, setSummaryRunCount] = useState(0);
    const [summary_input_count, setSummaryInputCount] = useState(0);
    const [summary_input_error_count, setSummaryInputErrorCount] = useState(0);
    const [summary_exam_count, setSummaryExamCount] = useState(0);
    const [summary_exam_ok_count, setSummaryExamOKCount] = useState(0);
    const [summary_exam_ng_count, setSummaryExamNGCount] = useState(0);

    useEffect(() => {
        if (machineInfo.length > 0) {
            const first = machineInfo[0];
            setTabID(String(first.machine_id));
            setTabType(first.machine_type ?? null);
        }
    }, [machineInfo]);

    useEffect(() => {
        handleView();
    }, [tabID]);

    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
            handleSetting();
        }
    }, [MenuID])

    useEffect(() => {
        const accessList = JSON.parse(localStorage.getItem("nav"));
        
        if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
            setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
            setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
            setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
            setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
            setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
            setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);

            // 설비 정보
            axios.get('/api/p/MachineRuningStatus/machineInfo')
            .then((response) => { 
                let full_array = [];
                for(let i = 0; i < response.data.length; i++) {
                    let data = response.data[i]
                    let temp_data = {
                        machine_id : data.machine_id,
                        machine_type : data.machine_type,
                        machine_resource_id : data.machine_resource_id,
                        machine_name : data.machine_name,
                        machine_ip : data.machine_ip,
                        machine_port : data.machine_port,
                        machine_location : data.machine_location,
                        machine_comment : data.machine_comment,
                    }
                    full_array.push(temp_data)
                }
                setMachineInfo(full_array);
            })
            .catch((error) => {
                appStore.capture();
            });
        }else{
            Swal.fire({
                title: '<p style="color:red">접근 권한 오류</p>',
                text: '화면에 접근 권한이 없습니다.',
                confirmButtonText: '확인',
                confirmButtonColor: '#7066e0',
                timer:5000,
                timerProgressBar: true
            }).then((value) => {
                return navigate(-1);
            });
        };
    }, []);
    
    const handleView = () => {
        if(typeof tabID === 'undefined' || typeof tabType === 'undefined'){
            return;
        }

        if (appStore.loading) return;
        appStore.setLoading(true);

        setSummaryRunTime('00:00');
        setSummaryRunPredictCount(0);
        setSummaryRunCount(0);
        setSummaryInputCount(0);
        setSummaryInputErrorCount(0);
        setSummaryExamCount(0);
        setSummaryExamOKCount(0);
        setSummaryExamNGCount(0);

        if(String(tabType) == '1'){

            //가동상태 데이터 호출
            axios.get('/api/p/MachineRuningStatus/SelectRunStatus',
                {
                    params : {
                        id : tabID
                    }
                },
                { withCredentials: true }
            )
            .then((response) => {
                let reset = 0
                let stop = 0
                let hold = 0
                let start = 0
                let mstr = 0
                
                for(let i = 0; i < response.data.length; i++) {
                    let data = response.data[i];

                    if(data.status_run == '0'){
                        reset = data.sum_produce_time
                    } else if (data.status_run == '1') {
                        stop = data.sum_produce_time
                    } else if (data.status_run == '2') {
                        hold = data.sum_produce_time
                    } else if (data.status_run == '3') {
                        start = data.sum_produce_time
                    } else if (data.status_run == '4') {
                        mstr = data.sum_produce_time
                    }
                }
                setRunPieData([
                    ["상태", "가동률"],
                    ["가동", start],
                    ["정지", stop],
                    ["홀드", hold],
                    ["MSRT", mstr],
                    ["오프라인", reset],
                ]);
                setSummaryRunTime((start==null || isNaN(start))? '-': `${String(Math.floor(start/60)).padStart(2,'0')}:${String(start%60).padStart(2,'0')}`);
            })
            .catch((error) => {
                appStore.capture();
            });

            // 가동모드 데이터 호출
            axios.get('/api/p/MachineRuningStatus/SelectAutStatus',
                {
                    params : {
                        id : tabID
                    }
                },
                { withCredentials: true }
            )
            .then((response) => {
                let MDI = 0
                let EDIT = 0
                let HND = 0
                let JOG = 0
                let REF = 0
                let MEM = 0
                let ETC = 0
                
                for(let i = 0; i < response.data.length; i++) {
                    let data = response.data[i];

                    if(data.status_aut == '0'){
                        MDI = data.sum_produce_time
                    } else if (data.status_aut == '10' || data.status_aut == '2' || data.status_aut == '6' || data.status_aut == '7' || data.status_aut == '8') {
                        ETC = ETC + data.sum_produce_time
                    } else if (data.status_aut == '3') {
                        EDIT = data.sum_produce_time
                    } else if (data.status_aut == '4') {
                        HND = data.sum_produce_time
                    } else if (data.status_aut == '5') {
                        JOG = data.sum_produce_time
                    } else if (data.status_aut == '9') {
                        REF = data.sum_produce_time
                    } else if (data.status_aut == '1') {
                        MEM = data.sum_produce_time
                    }
                }
                setAutPieData([
                    ["Element", "분", { role: "style" }],
                    ["MDI", MDI, "color:rgb(245, 123, 123)"],
                    ["MEM", MEM, "color:rgb(232, 215, 105)"],
                    ["EDIT", EDIT, "color:rgb(128, 236, 104)"],
                    ["HND", HND, "color: rgb(88, 136, 233)"],
                    ["JOG", JOG, "color:rgb(212, 95, 239)"],
                    ["REF", REF, "color:rgb(57, 54, 54)"],
                    ["ETC", ETC, "color:rgb(211, 141, 43)"]
                ]);
            })
            .catch((error) => {
                appStore.capture();
            });

            //프로젝트 호출
            axios.get('/api/p/MachineRuningStatus/SelectProjectName',
                {
                    params : {
                        id : tabID
                    }
                },
                { withCredentials: true }
            )
            .then((response) => {
                let sum_produce_count = 0;
                let temp_array = [["비율", "프로젝트"],];
                for(let i = 0; i < response.data.length; i++) {
                    let data = response.data[i];
                    let temp_data = [ // 이번에 들어갈 데이터
                        [data.project_name, data.sum_produce_count],
                    ]
                    temp_array = temp_array.concat(temp_data)
                    sum_produce_count = Number(sum_produce_count) + Number(data.sum_produce_count)
                }
                setProjectPie(temp_array);
                setSummaryRunCount(sum_produce_count);
            })
            .catch((error) => {
                appStore.capture();
            });

            //실적 데이터
            axios.get('/api/p/MachineRuningStatus/SelectInputData',
                {
                    params : {
                        id : tabID
                    }
                },
                { withCredentials: true }
            )
            .then((response) => {
                setSummaryInputCount(Number(response.data[0].sum_input_produce_count))
                setSummaryInputErrorCount(Number(response.data[0].sum_input_error_produce_count))
            })
            .catch((error) => {
                appStore.capture();
            });
        }
        
        // 가동 grid 데이터 호출
        let grid_length = 0;
        axios.get('/api/p/MachineRuningStatus/List',
            {
                params : {
                    id : tabID,
                    type : tabType
                }
            },
            { withCredentials: true }
        )
        .then((response) => {
            grid_length = response.data.length;
            
            let array = []
            let status_array = [["상태", "상태값"]];
            let error_array = [["상태", "불량율"]];
            let error_type_array = [["상태", "불량유형"]];
            
            if(String(tabType) == '1'){
                array = response.data.map((item, index) => ({
                    id: index,
                    date: Moment(item.gijun_datetime).format('YYYY-MM-DD HH:mm:ss'),
                    project_name: item.project_name,
                    target_count: item.target_count,
                    produce_count: item.produce_count,
                    run: item.status_run_name,
                    aut: item.status_aut_name,
                    logdata: item.logdata
                }));
                setRows(array);
            }else if(String(tabType) == '2'){
                array = response.data.map((item, index) => ({
                    id: index,
                    date: Moment(item.gijun_datetime).format('YYYY-MM-DD HH:mm:ss'),
                    status_name: item.status_name,
                    logdata: item.logdata
                }));
                setRows(array);

                setSummaryRunPredictCount(response.data.filter(
                    r => String(r.status) === '1' || r.status_name === '가동'
                ).length);
                
                if(response.data.length > 0){
                    status_array = ([
                        ["상태", "상태값"],
                        ["가동", response.data[0].run_min ?? 0],
                        ["정지", response.data[0].stop_min ?? 0],
                    ]);
                }
                    
                setStatusPie(status_array);
                setSummaryRunTime(((response.data[0].run_min)==null || isNaN((response.data[0].run_min)))? '-': `${String(Math.floor((response.data[0].run_min)/60)).padStart(2,'0')}:${String((response.data[0].run_min)%60).padStart(2,'0')}`);
            }else if(String(tabType) == '4'){
                array = response.data.map((item, index) => ({
                    id: index,
                    date: Moment(item.gijun_datetime).format('YYYY-MM-DD HH:mm:ss'),
                    produce_count: item.d_total,
                    produce_ok_count: item.d_ok,
                    produce_ng_count: item.d_ng,
                    status_name: item.status_name,
                    logdata: item.logdata
                }));
                setRows(array);
                
                if(response.data.length > 0){
                    status_array = ([
                        ["상태", "상태값"],
                        ["가동", response.data[0].run_min ?? 0],
                        ["정지", response.data[0].stop_min ?? 0],
                    ]);
                    error_array = ([
                        ["상태", "불량율"],
                        ["OK", response.data[0].s_ok ?? 0],
                        ["NG", response.data[0].s_ng ?? 0],
                    ]);
                    error_type_array = ([
                        ["상태", "불량유형"],
                        [response.data[0].ng1_label, response.data[0].sum_d_ng1 ?? 0],
                        [response.data[0].ng2_label, response.data[0].sum_d_ng2 ?? 0],
                        [response.data[0].ng3_label, response.data[0].sum_d_ng3 ?? 0],
                        [response.data[0].ng4_label, response.data[0].sum_d_ng4 ?? 0],
                        [response.data[0].ng5_label, response.data[0].sum_d_ng5 ?? 0]
                    ]);
                } 
                setStatusPie(status_array);
                setErrorPie(error_array);
                setErrorTypePie(error_type_array);
                setSummaryRunTime(((response.data[0].run_min)==null || isNaN((response.data[0].run_min)))? '-': `${String(Math.floor((response.data[0].run_min)/60)).padStart(2,'0')}:${String((response.data[0].run_min)%60).padStart(2,'0')}`);
                setSummaryExamCount(Number(response.data[0].s_ok) + Number(response.data[0].s_ng));
                setSummaryExamOKCount(Number(response.data[0].s_ok));
                setSummaryExamNGCount(Number(response.data[0].s_ng));
            }
        })
        .catch((error) => {
            appStore.capture();
        });

        // 타임라인 데이터 호출
        axios.get('/api/p/MachineRuningStatus/TimeLineData',
            {
                params : {
                    id : tabID
                }
            },
            { withCredentials: true }
        )
        .then((response) => {
            if(grid_length == 0 && (String(tabType) == '2' || String(tabType) == '4')){
                const list = response.data ?? [];

                const minutesBetween = (start, end) => {
                const s = new Date(start);
                const e = new Date(end || new Date().toISOString()); // end가 없으면 현재시각
                const diffMs = e - s;
                    return Number.isFinite(diffMs) ? Math.max(0, Math.round(diffMs / 60000)) : 0;
                };

                let run_min = 0;
                let stop_min = 0;

                for (const row of list) {
                    const mins = minutesBetween(row.start_datetime, row.end_datetime);
                    if (String(row.status_run) === '1') {
                        run_min += mins;    // 가동
                    } else if (String(row.status_run) === '0') {
                        stop_min += mins;   // 정지
                    }
                }

                // 원하는 형태로 구성
                setStatusPie([
                    ["상태", "상태값"],
                    ["가동", run_min],
                    ["정지", stop_min],
                ]);
            }

            let temp_array = [ // 타임라인 데이터 임시 배열
                [
                    { type: "string", id: "Room" },
                    { type: "string", id: "Name" },
                    { type: "date", id: "Start" },
                    { type: "date", id: "End" },
                ],
            ]
            let temp_color_array = [] // 타임라인 색상 임시 배열
            // 마지막 24시를 위한 임시데이터
            let last_hour = ''
            let last_min = ''
            let last_sec = ''
            let temp_start_hour = '';
            let temp_start_min = '';
            let temp_start_sec = '';
            let temp_end_hour = '';
            let temp_end_min = '';
            let temp_end_sec = '';
            let temp_status = '';
            let temp_status_name = '';
            let temp_status_color = '';

            let status_0 = 'N';
            let status_1 = 'N';
            let status_2 = 'N';
            let status_3 = 'N';
            let status_4 = 'N'; 
            for(let i = 0; i < response.data.length; i++) {
                let addYN = 'N';
                let data = response.data[i];

                if(data.status_run !== temp_status){
                    temp_start_hour = Moment(data.start_datetime).format('HH');
                    temp_start_min = Moment(data.start_datetime).format('mm');
                    temp_start_sec = Moment(data.start_datetime).format('ss');
                }
                
                temp_status = data.status_run;
                
                if(i === (response.data).length-1 || temp_status !== (response.data[i+1]).status_run){
                    
                    addYN = 'Y'
                    temp_end_hour = Moment(data.end_datetime).format('HH');
                    temp_end_min = Moment(data.end_datetime).format('mm');
                    temp_end_sec = Moment(data.end_datetime).format('ss');

                    if(String(data.machine_type) === '1'){
                        //run 동작상태 # 0 : 오프라인 , 1 : 정지 , 2 : 홀드 , 3 : 가동 , 4 : MSTR
                        if(Number(temp_status) === 0 || Number(temp_status) === -1){
                            temp_status_name = '오프라인'
                            temp_status_color = 'rgb(57, 54, 54)'
                            if(status_0 === 'N'){
                                temp_color_array = temp_color_array.concat('rgb(57, 54, 54)')
                            }
                            status_0 = 'Y'
                        } else if (Number(temp_status) === 1){
                            temp_status_name = '정지'
                            temp_status_color = '#D84B16'
                            if(status_1 === 'N'){
                                temp_color_array = temp_color_array.concat('#D84B16')
                            }
                            status_1 = 'Y'
                        } else if (Number(temp_status) === 2){
                            temp_status_name = '홀드'
                            temp_status_color = '#FFB737'
                            if(status_2 === 'N'){
                                temp_color_array = temp_color_array.concat('#FFB737')
                            }
                            status_2 = 'Y'
                        } else if (Number(temp_status) === 3){
                            temp_status_name = '가동'
                            temp_status_color = 'rgb(104, 171, 38)'
                            if(status_3 === 'N'){
                                temp_color_array = temp_color_array.concat('rgb(104, 171, 38)')
                            }
                            status_3 = 'Y'
                        } else if (Number(temp_status) === 4){
                            temp_status_name = 'MSTR'
                            temp_status_color = '#F1A7C9'
                            if(status_4 === 'N'){
                                temp_color_array = temp_color_array.concat('#F1A7C9')
                            }
                            status_4 = 'Y'
                        }
                    } else if(String(data.machine_type) === '2' || String(data.machine_type) === '4'){
                         if (Number(temp_status) === 0 || Number(temp_status) === -1){
                            temp_status_name = '정지'
                            temp_status_color = '#D84B16'
                            if(status_1 === 'N'){
                                temp_color_array = temp_color_array.concat('#D84B16')
                            }
                            status_1 = 'Y'
                        } else if (Number(temp_status) === 1){
                            temp_status_name = '가동'
                            temp_status_color = 'rgb(104, 171, 38)'
                            if(status_3 === 'N'){
                                temp_color_array = temp_color_array.concat('rgb(104, 171, 38)')
                            }
                            status_3 = 'Y'
                        }
                    }
                }
                

                if(addYN === 'Y'){
                    let temp_data = [[ // 이번에 들어갈 데이터
                        "기간",
                        temp_status_name,
                        new Date(0, 0, 0, temp_start_hour, temp_start_min, temp_start_sec),
                        new Date(0, 0, 0, temp_end_hour, temp_end_min, temp_end_sec),
                    ]]
                    if(temp_start_hour||'$'||temp_start_min||'$'||temp_start_sec !== temp_end_hour||'$'||temp_end_min||'$'||temp_end_sec){
                        temp_array = temp_array.concat(temp_data)
                    }
                }
            }
            
            // 마지막 24시를 위한 임시데이터
            last_hour = temp_end_hour;
            last_min = temp_end_min;
            last_sec = temp_end_sec;
            let temp_data = [[
                // 마지막 24시간 데이터 추가
                "기간",
                '데이터 수집중',
                new Date(0, 0, 0, last_hour, last_min, last_sec),
                new Date(0, 0, 0, 24, 0, 0),
            ]]
            temp_array = temp_array.concat(temp_data)
            temp_color_array = temp_color_array.concat('rgb(255, 255, 255)')
            
            setTimeLineOption(
                {
                    timeline: { showRowLabels: false },
                    avoidOverlappingGridLines: false,
                    colors: temp_color_array,
                }
            )
            setTimeLineData(temp_array)
            setMachineReady('Y');
        })
        .catch((error) => {
            appStore.capture();
        })
        .finally(() => {
            appStore.setLoading(false);
        });
    }

    const handleTabID = (event, newTabID) => {
        setTabID(newTabID);
        
        // machine_id와 일치하는 항목 찾기
        const selected = machineInfo.find(m => String(m.machine_id) === String(newTabID));

        if (selected) {
            setTabType(selected.machine_type);
        } else {
            setTabType(null); // 못 찾았을 때 기본값
        }
    };
    
    return (
        <div style={ { width:'100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' } }>
            <div className="menubox" style={ { height: '70px' } }>
                <div className="menu-action">
                    <div className="menu-title">{ MenuName }</div>
                </div>
            </div>
            {(machineReady === 'Y' && machineInfo.length > 0)?
            <>
            <div className="grid" style={ { top: '73px', height: 'calc(100% - 73px)'} }>
            <TabContext value={tabID}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleTabID} style={{ paddingLeft: '20px'}}>
                    {machineInfo.length > 0 && machineInfo.map((item, index) => (
                     <Tab key={index} label={item.machine_name} value={String(item.machine_id)} />
                    ))}
                </TabList>
                </Box>
                {machineInfo.length > 0 && machineInfo.map((item, index) => (
                    <TabPanel key={index} value={String(item.machine_id)} style={ { height: '470px'} }>
                        <div style={ {  padding: '10px', paddingTop: '0px', textAlign:'center', fontWeight: 'bold', fontSize: '24px', height: '100px' } }>
                            <Chart
                                chartType="Timeline"
                                data={timeLineData}
                                options={timeLineOption}
                                width="100%"
                                height="100px"
                            />
                        </div>

                        {/* === KPI Cards: 카드 자체에 왼쪽 패널 배경(graduent) 적용 === */}
                        <div
                        style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
                            gap: '14px',
                            padding: '8px 12px 2px 12px'
                        }}
                        >
                            {/* 가동시간 */}
                            {(item.machine_type == '1' || item.machine_type == '2' || item.machine_type == '4')? 
                            <>
                            <div
                                style={{
                                background: 'linear-gradient(90deg, #f3f4f6 0px, #f3f4f6 128px, #ffffff 128px)',
                                border: '1px solid #e6e9f0',
                                borderRadius: '14px',
                                padding: '12px 0px',
                                boxShadow: '0 2px 6px rgba(16,24,40,0.06)'
                                }}
                            >
                                <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', columnGap: '28px', rowGap: '10px' }}>
                                <div style={{ width: '128px', textAlign: 'center', fontSize: '24px', fontWeight: 700, color: '#6b7280', letterSpacing: '.2px', whiteSpace: 'nowrap' }}>
                                    가동시간
                                </div>
                                <div style={{ fontWeight: 800, fontSize: '32px', lineHeight: 1.1, color: '#111827', whiteSpace: 'nowrap' }}>
                                    {summary_run_time ?? '-'}
                                </div>
                                </div>
                            </div>
                            </>:<></>}

                            {/* 생산수량 */}
                            {(item.machine_type == '1')? 
                            <>
                            <div
                                style={{
                                background: 'linear-gradient(90deg, #f3f4f6 0px, #f3f4f6 128px, #ffffff 128px)',
                                border: '1px solid #e6e9f0',
                                borderRadius: '14px',
                                padding: '12px 0px',
                                boxShadow: '0 2px 6px rgba(16,24,40,0.06)'
                                }}
                            >
                                <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', columnGap: '28px', rowGap: '10px' }}>
                                <div style={{ width: '128px', textAlign: 'center', fontSize: '24px', fontWeight: 700, color: '#6b7280', letterSpacing: '.2px', whiteSpace: 'nowrap' }}>
                                    생산수량
                                </div>
                                <div style={{ fontWeight: 800, fontSize: '32px', lineHeight: 1.1, color: '#111827', display: 'flex', alignItems: 'baseline', gap: '8px', whiteSpace: 'nowrap' }}>
                                    {(summary_run_count === 0 || !!summary_run_count) ? Number(summary_run_count).toLocaleString() : '0'}
                                    <span style={{ fontSize: '18px', fontWeight: 600, color: '#9aa0a6' }}>EA</span>
                                </div>
                                </div>
                            </div>
                            </>:<></>}

                            {/* 예상생산수량 */}
                            {(item.machine_type == '2')? 
                            <>
                            <div
                                style={{
                                background: 'linear-gradient(90deg, #f3f4f6 0px, #f3f4f6 158px, #ffffff 158px)',
                                border: '1px solid #e6e9f0',
                                borderRadius: '14px',
                                padding: '12px 0px',
                                boxShadow: '0 2px 6px rgba(16,24,40,0.06)'
                                }}
                            >
                                <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', columnGap: '28px', rowGap: '10px' }}>
                                <div style={{ width: '158px', textAlign: 'center', fontSize: '24px', fontWeight: 700, color: '#6b7280', letterSpacing: '.2px', whiteSpace: 'nowrap' }}>
                                    예상생산수량
                                </div>
                                <div style={{ fontWeight: 800, fontSize: '32px', lineHeight: 1.1, color: '#111827', display: 'flex', alignItems: 'baseline', gap: '8px', whiteSpace: 'nowrap' }}>
                                    {(summary_run_predict_count === 0 || !!summary_run_predict_count) ? Number(summary_run_predict_count).toLocaleString() : '0'}
                                    <span style={{ fontSize: '18px', fontWeight: 600, color: '#9aa0a6' }}>EA</span>
                                </div>
                                </div>
                            </div>
                            </>:<></>}

                            {/* 실적수량 */}
                            {(item.machine_type == '1')? 
                            <>
                            <div
                                style={{
                                background: 'linear-gradient(90deg, #f3f4f6 0px, #f3f4f6 128px, #ffffff 128px)',
                                border: '1px solid #e6e9f0',
                                borderRadius: '14px',
                                padding: '12px 0px',
                                boxShadow: '0 2px 6px rgba(16,24,40,0.06)'
                                }}
                            >
                                <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', columnGap: '28px', rowGap: '10px' }}>
                                <div style={{ width: '128px', textAlign: 'center', fontSize: '24px', fontWeight: 700, color: '#6b7280', letterSpacing: '.2px', whiteSpace: 'nowrap' }}>
                                    실적수량
                                </div>
                                <div style={{ fontWeight: 800, fontSize: '32px', lineHeight: 1.1, color: '#111827', display: 'flex', alignItems: 'baseline', gap: '8px', whiteSpace: 'nowrap' }}>
                                    {(summary_input_count === 0 || !!summary_input_count) ? Number(summary_input_count).toLocaleString() : '0'}
                                    <span style={{ fontSize: '18px', fontWeight: 600, color: '#9aa0a6' }}>EA</span>
                                </div>
                                </div>
                            </div>
                            </>:<></>}

                            {/* 불량수량 */}
                            {(item.machine_type == '1')? 
                            <>
                            <div
                                style={{
                                background: 'linear-gradient(90deg, #f3f4f6 0px, #f3f4f6 128px, #ffffff 128px)',
                                border: '1px solid #e6e9f0',
                                borderRadius: '14px',
                                padding: '12px 0px',
                                boxShadow: '0 2px 6px rgba(16,24,40,0.06)'
                                }}
                            >
                                <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', columnGap: '28px', rowGap: '10px' }}>
                                <div style={{ width: '128px', textAlign: 'center', fontSize: '24px', fontWeight: 700, color: '#6b7280', letterSpacing: '.2px', whiteSpace: 'nowrap' }}>
                                    불량수량
                                </div>
                                <div style={{ fontWeight: 800, fontSize: '32px', lineHeight: 1.1, color: '#111827', display: 'flex', alignItems: 'baseline', gap: '8px', whiteSpace: 'nowrap' }}>
                                    {(summary_input_error_count === 0 || !!summary_input_error_count) ? Number(summary_input_error_count).toLocaleString() : '0'}
                                    <span style={{ fontSize: '18px', fontWeight: 600, color: '#9aa0a6' }}>EA</span>
                                </div>
                                </div>
                            </div>
                            </>:<></>}

                            {/* 검사수량 */}
                            {(item.machine_type == '4')? 
                            <>
                            <div
                                style={{
                                background: 'linear-gradient(90deg, #f3f4f6 0px, #f3f4f6 128px, #ffffff 128px)',
                                border: '1px solid #e6e9f0',
                                borderRadius: '14px',
                                padding: '12px 0px',
                                boxShadow: '0 2px 6px rgba(16,24,40,0.06)'
                                }}
                            >
                                <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', columnGap: '28px', rowGap: '10px' }}>
                                <div style={{ width: '128px', textAlign: 'center', fontSize: '24px', fontWeight: 700, color: '#6b7280', letterSpacing: '.2px', whiteSpace: 'nowrap' }}>
                                    검사수량
                                </div>
                                <div style={{ fontWeight: 800, fontSize: '32px', lineHeight: 1.1, color: '#111827', display: 'flex', alignItems: 'baseline', gap: '8px', whiteSpace: 'nowrap' }}>
                                    {(summary_exam_count === 0 || !!summary_exam_count) ? Number(summary_exam_count).toLocaleString() : '0'}
                                    <span style={{ fontSize: '18px', fontWeight: 600, color: '#9aa0a6' }}>EA</span>
                                </div>
                                </div>
                            </div>
                            </>:<></>}

                            {/* 양품수량 */}
                            {(item.machine_type == '4')? 
                            <>
                            <div
                                style={{
                                background: 'linear-gradient(90deg, #f3f4f6 0px, #f3f4f6 128px, #ffffff 128px)',
                                border: '1px solid #e6e9f0',
                                borderRadius: '14px',
                                padding: '12px 0px',
                                boxShadow: '0 2px 6px rgba(16,24,40,0.06)'
                                }}
                            >
                                <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', columnGap: '28px', rowGap: '10px' }}>
                                <div style={{ width: '128px', textAlign: 'center', fontSize: '24px', fontWeight: 700, color: '#6b7280', letterSpacing: '.2px', whiteSpace: 'nowrap' }}>
                                    양품수량
                                </div>
                                <div style={{ fontWeight: 800, fontSize: '32px', lineHeight: 1.1, color: '#111827', display: 'flex', alignItems: 'baseline', gap: '8px', whiteSpace: 'nowrap' }}>
                                    {(summary_exam_ok_count === 0 || !!summary_exam_ok_count) ? Number(summary_exam_ok_count).toLocaleString() : '0'}
                                    <span style={{ fontSize: '18px', fontWeight: 600, color: '#9aa0a6' }}>EA</span>
                                </div>
                                </div>
                            </div>
                            </>:<></>}

                            {/* 불량수량 */}
                            {(item.machine_type == '4')? 
                            <>
                            <div
                                style={{
                                background: 'linear-gradient(90deg, #f3f4f6 0px, #f3f4f6 128px, #ffffff 128px)',
                                border: '1px solid #e6e9f0',
                                borderRadius: '14px',
                                padding: '12px 0px',
                                boxShadow: '0 2px 6px rgba(16,24,40,0.06)'
                                }}
                            >
                                <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', columnGap: '28px', rowGap: '10px' }}>
                                <div style={{ width: '128px', textAlign: 'center', fontSize: '24px', fontWeight: 700, color: '#6b7280', letterSpacing: '.2px', whiteSpace: 'nowrap' }}>
                                    불량수량
                                </div>
                                <div style={{ fontWeight: 800, fontSize: '32px', lineHeight: 1.1, color: '#111827', display: 'flex', alignItems: 'baseline', gap: '8px', whiteSpace: 'nowrap' }}>
                                    {(summary_exam_ng_count === 0 || !!summary_exam_ng_count) ? Number(summary_exam_ng_count).toLocaleString() : '0'}
                                    <span style={{ fontSize: '18px', fontWeight: 600, color: '#9aa0a6' }}>EA</span>
                                </div>
                                </div>
                            </div>
                            </>:<></>}
                            
                        </div>

                        {(item.machine_type == '1')?
                            <>
                            <div style={ { width: '100%' } }>
                                <div style={{ float: 'left', width: '33.3%'}}>
                                    <div style={{ width: '100%', height: '330px' }}>
                                        <ResponsiveContainer>
                                            <Chart
                                                chartType="PieChart"
                                                data={runPieData}
                                                options={runPie_option}
                                            />
                                        </ResponsiveContainer>
                                    </div>
                                </div>
                                <div style={{ float: 'left', width: '33.3%'}}>
                                    <div style={{ width: '100%', height: '330px' }}>
                                        <ResponsiveContainer>
                                            <Chart 
                                                chartType="PieChart" 
                                                data={autPieData} 
                                                options={antPie_option}
                                            />
                                        </ResponsiveContainer>
                                    </div>
                                </div>
                                <div style={{ float: 'right', width: '33.3%'}}>
                                    <div style={{ width: '100%', height: '330px' }}>
                                        <ResponsiveContainer>
                                            <Chart 
                                                chartType="PieChart" 
                                                data={projectPie} 
                                                options={projectPie_option}
                                            />
                                        </ResponsiveContainer>
                                    </div>
                                </div>
                            </div>
                            {/*
                            <div className="grid_sub" style={ { width: '100%', height: '300px', fontSize: '17px' } }>
                                <DataGrid
                                    className="grid_main"
                                    rows={rows}
                                    columns={columns}
                                    slots={{
                                        noRowsOverlay: GridNoRow,
                                    }}
                                    columnVisibilityModel={columnVisibilityModel}
                                    AlternatingRowBackground="LavenderBlush"
                                    rowsPerPageOptions={[5, 50, 100]}
                                />
                            </div>
                            */}
                            </>
                            : 
                            (item.machine_type == '2')?
                            <>
                            <div style={ { width: '100%' } }>
                                <div style={{ float: 'left', width: '33.3%'}}>
                                    <div style={{ width: '100%', height: '330px' }}>
                                        <ResponsiveContainer>
                                            <Chart
                                                chartType="PieChart"
                                                data={statusPie}
                                                options={statusPie_option}
                                            />
                                        </ResponsiveContainer>
                                    </div>
                                </div>
                                <div style={{ float: 'left', width: '33.3%'}}>
                                    <div style={{ width: '100%', height: '330px' }}>
                                    </div>
                                </div>
                                <div style={{ float: 'right', width: '33.3%'}}>
                                    <div style={{ width: '100%', height: '330px' }}>
                                    </div>
                                </div>
                            </div>
                            {/*
                            <div className="grid_sub" style={ { width: '100%', height: '300px', fontSize: '17px' } }>
                                <DataGrid
                                    className="grid_main"
                                    rows={rows}
                                    columns={columns2}
                                    slots={{
                                        noRowsOverlay: GridNoRow,
                                    }}
                                    columnVisibilityModel={columnVisibilityModel}
                                    AlternatingRowBackground="LavenderBlush"
                                    rowsPerPageOptions={[5, 50, 100]}
                                />
                            </div>
                            */}
                            </>
                            :
                            <>
                            <div style={ { width: '100%' } }>
                                <div style={{ float: 'left', width: '33.3%'}}>
                                    <div style={{ width: '100%', height: '330px' }}>
                                        <ResponsiveContainer>
                                            <Chart
                                                chartType="PieChart"
                                                data={statusPie}
                                                options={statusPie_option}
                                            />
                                        </ResponsiveContainer>
                                    </div>
                                </div>
                                <div style={{ float: 'left', width: '33.3%'}}>
                                    <div style={{ width: '100%', height: '330px' }}>
                                        <ResponsiveContainer>
                                            <Chart 
                                                chartType="PieChart" 
                                                data={errorPie} 
                                                options={errorPie_option}
                                            />
                                        </ResponsiveContainer>
                                    </div>
                                </div>
                                <div style={{ float: 'right', width: '33.3%'}}>
                                    <div style={{ width: '100%', height: '330px' }}>
                                        <ResponsiveContainer>
                                            <Chart 
                                                chartType="PieChart" 
                                                data={errorTypePie} 
                                                options={errorTypePie_option}
                                            />
                                        </ResponsiveContainer>
                                    </div>
                                </div>
                            </div>
                            {/*
                            <div className="grid_sub" style={ { width: '100%', height: '300px', fontSize: '17px' } }>
                                <DataGrid
                                    className="grid_main"
                                    rows={rows}
                                    columns={columns4}
                                    slots={{
                                        noRowsOverlay: GridNoRow,
                                    }}
                                    columnVisibilityModel={columnVisibilityModel}
                                    AlternatingRowBackground="LavenderBlush"
                                    rowsPerPageOptions={[5, 50, 100]}
                                />
                            </div>
                            */}  
                            </>
                        }
                    </TabPanel>
                ))}
            </TabContext>
            </div>
            </>
            :
            <></>}
        </div>
    )
}

const AppWrap = styled.div`
  text-align: center;
  margin: 50px auto;
`;
export default MachineRuningStatus;